import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const layoutDefaultVariants = {}
const layoutCompoundVariants = []

const layoutSlotNames = [
  [
    "zenidContainer",
    "layout__zenidContainer"
  ],
  [
    "mainContentsContainer",
    "layout__mainContentsContainer"
  ],
  [
    "mainContentsInnerContainer",
    "layout__mainContentsInnerContainer"
  ],
  [
    "errorContainer",
    "layout__errorContainer"
  ]
]
const layoutSlotFns = /* @__PURE__ */ layoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, layoutDefaultVariants, getSlotCompoundVariant(layoutCompoundVariants, slotName))])

const layoutFn = memo((props = {}) => {
  return Object.fromEntries(layoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const layoutVariantKeys = []
const getVariantProps = (variants) => ({ ...layoutDefaultVariants, ...compact(variants) })

export const layout = /* @__PURE__ */ Object.assign(layoutFn, {
  __recipe__: false,
  __name__: 'layout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: layoutVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, layoutVariantKeys)
  },
  getVariantProps
})